/**
 * Storage Keys
 *
 * Centralized constants for all AsyncStorage keys.
 * Prevents typos and makes key management easier.
 */

// Authentication keys
export const AUTH_KEYS = {
  TOKEN: 'token',
  METHOD: 'method', // 'login' or 'qr'
  IS_ADMIN: 'isAdmin',
  IS_USER_ADMIN: 'isUserAdmin',
  IS_ORG_ADMIN: 'isOrgAdmin',
  IS_ACCOUNT_OWNER: 'isAccountOwner',
  IS_MONETA: 'isMoneta',
};

// Organization keys
export const ORG_KEYS = {
  ORGANIZATION: 'organization',
  ORGANIZATION_ACCESS: 'organizationAccess',
  ROUTING: 'routing',
  FEATURES: 'features',
};

// Report cache keys
export const REPORT_CACHE_KEYS = {
  REPORT_CHANGED: 'reportChanged',
  REPORT_COMMENTED: 'reportCommented',
  REPORT_CLOSED: 'reportClosed',
  REPORT_REOPENED: 'reportReopened',
};

// UI preferences keys
export const UI_PREFERENCES_KEYS = {
  ANALYTICS_SECTION_STATE: '@analytics_section_state',
  QUIET_MODE: 'quietMode',
  // 'en' | 'es' | 'system'. Deliberately absent from LOGOUT_KEYS below so the
  // login screen stays translated after a sign-out.
  LANGUAGE: 'language',
};

// All keys for easier iteration
export const ALL_KEYS = {
  ...AUTH_KEYS,
  ...ORG_KEYS,
  ...REPORT_CACHE_KEYS,
  ...UI_PREFERENCES_KEYS,
};

// Keys to clear on logout
export const LOGOUT_KEYS = [
  AUTH_KEYS.TOKEN,
  AUTH_KEYS.IS_ADMIN,
  AUTH_KEYS.IS_USER_ADMIN,
  AUTH_KEYS.IS_ORG_ADMIN,
  AUTH_KEYS.IS_ACCOUNT_OWNER,
  AUTH_KEYS.IS_MONETA,
  ORG_KEYS.ORGANIZATION_ACCESS,
  ORG_KEYS.ROUTING,
  ORG_KEYS.ORGANIZATION,
  ORG_KEYS.FEATURES,
];
